import React from 'react'
import Tour from 'reactour'
import { connect } from 'react-redux'
import { closeTour } from 'redux/actions/tour.actions'
import storage from 'helpers/storage'
import { Button } from '@chakra-ui/react'
import './_Tour.scss'

const AppTour = ({ isOpen, steps, closeTour }) => {
  if (!steps?.length) return null
  const onAfterOpen = () => {
    document.body.style.overflowY = 'hidden'
    document.documentElement.style.scrollBehavior = 'auto'
  }
  const onRequestClose = () => {
    document.body.style.overflowY = 'auto'
    document.documentElement.style.scrollBehavior = ''
    storage.set('guidedTourViewed', true)
    closeTour()
  }
  return (
    <Tour
      steps={steps}
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      lastStepNextButton={
        <Button as="div" color="brand.btn-alt" size="xs">
          Done!
        </Button>
      }
      startAt={0}
      scrollDuration={0}
      maskSpace={8}
      rounded={3}
      accentColor="var(--main)"
    />
  )
}

const mapStateToProps = state => ({
  steps: state.tour.steps,
  isOpen: state.tour.isOpen
})

const mapDispatchToProps = dispatch => ({
  closeTour: () => dispatch(closeTour())
})

export default connect(mapStateToProps, mapDispatchToProps)(AppTour)
